import EventEmitter from "eventemitter3";
import StoreProps from "../types/Store";
import Store from "./Store";
import Translation from "./Translation";
import WindowSize from "./WindowSize";

class WeeklyOffers {
    EEE: EventEmitter;
    currentStore: StoreProps | undefined | null;
    offersWeeklyAreas: NodeListOf<HTMLElement>;
    offer_post: never[];
    limit: number;

    constructor() {
        this.limit = 6;
        this.offer_post = [];
        this.EEE = new EventEmitter();
        this.currentStore = undefined;
        this.offersWeeklyAreas = document.querySelectorAll(
            "#offers-weekly",
        ) as NodeListOf<HTMLElement>;
        this.init();
    }

    // init when offers blocks exist
    init() {
        if (this.offersWeeklyAreas.length > 0) {
            this.limit = WindowSize.isMobile() ? 4 : 6;

            this.addListeners();
            this.updateStore();
        }
    }

    // Add the store change listeners
    addListeners() {
        this.EEE.on("STORE_CHANGED", (id) => this.updateStore(id));
    }

    // Update active store
    updateStore(id?: number) {
        if (this.currentStore && id && this.currentStore.id !== id)
            Store.setStore(id);
        this.currentStore = Store.getCurrentStore();
        this.updateOffers();
    }

    setShowAll(offersWeekly: HTMLElement) {
        const centerContent = offersWeekly.querySelector(
            ".offers__center-content",
        ) as HTMLElement;
        if (centerContent) centerContent.style.display = "none";
        const offers = offersWeekly.querySelectorAll(
            ".offers__offer-item",
        ) as NodeListOf<HTMLElement>;
        offers.forEach((offer) => {
            offer.style.display = "";
        });
    }

    updateOffers() {
        this.offersWeeklyAreas.forEach((offersWeekly) => {
            const block = this.currentStore?.offers_weekly || undefined;
            const offers = block?.offers ?? [];

            const bottomContent = offersWeekly.querySelector(
                ".offers__bottom-content",
            ) as HTMLElement;
            const findUsButton = offersWeekly.querySelector(
                ".offers__find-us-button",
            ) as HTMLLinkElement;

            if (offers.length > 0) {
                offersWeekly.style.display = "";
                const heading = offersWeekly.querySelector(
                    ".offers__heading",
                ) as HTMLElement;
                const textTop = offersWeekly.querySelector(
                    ".offers__text-top",
                ) as HTMLElement;
                const bg = offersWeekly.querySelector(
                    ".offers__bg",
                ) as HTMLElement;
                const bgTop = offersWeekly.querySelector(
                    ".offers__bg--top",
                ) as HTMLElement;
                const bgBottom = offersWeekly.querySelector(
                    ".offers__bg--bottom",
                ) as HTMLElement;
                const offersList = offersWeekly.querySelector(
                    ".offers__offers-list",
                ) as HTMLElement;
                const centerContent = offersWeekly.querySelector(
                    ".offers__center-content",
                ) as HTMLElement;
                const openingHours = offersWeekly.querySelector(
                    ".offers__opening-hours",
                ) as HTMLElement;

                const bgColor = block?.bg_color || "";
                const backgroundImage =
                    block?.bg_image && block.bg_image.url
                        ? `url("${block.bg_image.url}")`
                        : "";
                const backgroundSize =
                    block?.bg_image && block.bg_image.url && block.bg_cover
                        ? "cover"
                        : "auto auto";

                if (heading)
                    heading.innerText =
                        block?.header + " " + this.currentStore?.title || "";

                if (textTop) textTop.innerText = block?.text_top || "";

                if (bg) {
                    if (offers.length === 0) bg.classList.add("offers__empty");
                    if (block?.bg_cover) bg.classList.add("offers__bg--cover");
                }

                if (bgTop) {
                    bgTop.style.backgroundColor = bgColor;
                    bgTop.style.backgroundImage = backgroundImage;
                    bgTop.style.backgroundSize = backgroundSize;
                }

                if (bgBottom) {
                    bgBottom.style.backgroundColor = bgColor;
                    bgBottom.style.backgroundImage = backgroundImage;
                    bgBottom.style.backgroundSize = backgroundSize;
                }

                if (offersList) {
                    offersList.innerText = "";

                    offers.forEach((offer, index) => {
                        offersList.innerHTML +=
                            `
							<li class="offers__offer-item" style="${
                                index > this.limit - 1 ? "display:none;" : ""
                            }">
                                <img
                                    src="${offer.image_url}?preset=small"
                                    class="offers__offer-item-image ${
                                        offer.image_mobile_url
                                            ? "offers__offer-item-image--desktop"
                                            : ""
                                    }"
									alt="${offer.image_alt}"
                                    loading="lazy"
                                    ${offer.image_height ? `height="${offer.image_height}"` : ""}
                                    ${offer.image_width ? `width="${offer.image_width}"` : ""}
                                />` +
                            (offer.image_mobile_url &&
                            offer.image_mobile_url != null
                                ? `
                                <img
                                    src="${offer.image_mobile_url}?preset=small"
                                    class="offers__offer-item-image offers__offer-item-image--mobile"
									alt="${offer.image_alt}"
                                    loading="lazy"
                                    ${offer.image_height_mobile ? `height="${offer.image_height_mobile}"` : ""}
                                    ${offer.image_width_mobile ? `width="${offer.image_width_mobile}"` : ""}
                                />`
                                : "") +
                            `
								<div class="offers__offer-item-text-wrapper">
									<p class="offers__offer-item-header">
										${offer.header}
									</p>
									<p class="offers__offer-item-text">
										${offer.text}
									</p>
									<p class="offers__offer-item-text">
										${offer.price}
									</p>
								</div>
							</li>`;
                    });
                }

                if (centerContent && offers && offers.length > this.limit) {
                    centerContent.innerText = "";
                    const button = document.createElement("button");
                    button.classList.add("button");
                    button.innerText = Translation.getText(
                        "Offer",
                        "SeAllOffers",
                    );
                    button.addEventListener("click", () =>
                        this.setShowAll(offersWeekly),
                    );
                    centerContent.appendChild(button);
                    centerContent.style.display = "";
                }

                if (bottomContent) {
                    bottomContent.innerText = "";
                    bottomContent.innerHTML = `${Translation.getText(
                        "Offer",
                        "AppliesForStore",
                    )} ${this.currentStore?.title || ""}<br />${Translation.getText(
                        "Offer",
                        "AllPriceIn",
                    )}<br /> ${Translation.getText(
                        "Offer",
                        "WithReservation",
                    )}`;
                }

                if (openingHours) {
                    openingHours.innerText =
                        this.currentStore?.opening_hours_small || "";
                }
                if (findUsButton) {
                    const storeTitle = this.currentStore?.title as string;
                    findUsButton.href = this.currentStore?.position
                        .address as string;
                    findUsButton.title = `Visa ${storeTitle} i Google Maps, öppnas i ny flik`;
                    findUsButton.ariaLabel = `Visa ${storeTitle} i Google Maps, öppnas i ny flik`;
                }
            } else {
                if (findUsButton) findUsButton.style.display = "none";
                if (bottomContent) bottomContent.style.display = "none";
            }
        });
    }
}

export default WeeklyOffers;
